/**
 * Evaluation Routes
 *
 * Titles/descriptions/breadcrumbs are auto-resolved by the i18n router
 * guard from each route's `name` — see `src/plugins/i18n/routeI18n.ts`.
 */

export default [
  {
    path: 'evaluation',
    name: 'evaluations.overview',
    component: () => import('../../pages/evaluations/OverallView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: 'evaluation/:evaluationID',
    name: 'evaluations.detail',
    component: () => import('../../pages/evaluations/DetailView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: 'evaluation/default',
    name: 'evaluations.default',
    component: () => import('../../pages/evaluations/DefaultEvaluation.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        redirect: '/evaluation/default/results'
      },
      {
        path: 'results',
        name: 'evaluations.default.results',
        component: () => import('../../pages/evaluations/tabs/Results.vue'),
        meta: { requiresAuth: true, breadcrumb: 'Results' }
      },
      {
        path: 'summaries',
        name: 'evaluations.default.summaries',
        component: () => import('../../pages/evaluations/tabs/Summaries.vue'),
        meta: { requiresAuth: true, breadcrumb: 'Summaries' }
      },
      {
        path: 'justifications',
        name: 'evaluations.default.justifications',
        component: () => import('../../pages/evaluations/tabs/Justifications.vue'),
        meta: { requiresAuth: true, breadcrumb: 'Justifications' }
      },
      {
        path: 'requirements',
        name: 'evaluations.default.requirements',
        component: () => import('../../pages/evaluations/tabs/Requirements.vue'),
        meta: { requiresAuth: true, breadcrumb: 'Requirements' }
      }
    ]
  },
  {
    path: 'evaluation/editCondition/:type/:index',
    name: 'evaluations.editCondition',
    component: () => import('../../pages/evaluations/EditEvaluationCondition.vue'),
    meta: { requiresAuth: true }
  }
]
